import HighlightedText from '@meettry/engineer/components/atoms/HighlightedText/HighlightedText';

export default HighlightedText;
